<du-config-detail [navigateBack]="{commands: [ConfigRouteEnum.TRANSLATIONS, applicationName]}">
<detail-header>
            @if (logoUrl && logoUrl.length > 0) {
                <img [ngSrc]="logoUrl" alt="{{applicationName}} logo" width="64" height="64" priority>
            }

            <div>
                <h1 class="detail-header-title">{{ applicationName }}</h1>
                <p class="detail-header-subtitle">{{ "#" + identification }}</p>
            </div>
</detail-header>
    <detail-header-action>
        <p-button (onClick)="saveAllTranslations()" [disabled]="translations.length === 0">
            <i class="pi pi-save"></i>
            {{ "button.save" | translate | uppercase }}
        </p-button>

        <p-button severity="secondary" (onClick)="addTranslation()" [disabled]="usableLanguages.length === 0 || translations.length === usableLanguages.length">
            <i class="pi pi-plus"></i>
            {{ "translation.add" | translate | uppercase }}
        </p-button>
    </detail-header-action>
<detail-body>
<form [formGroup]="form">
    <ng-container formArrayName="translations">
        @for (formGroup of translations.controls; track formGroup.value.id ?? $index; let i = $index) {
            <p-card class="translate-edit-card">
                <ng-container [formGroupName]="i">

                    <div class="field">
                        <label for="translation-language-{{i}}">Language</label>
                        <p-select inputId="translation-language-{{i}}" formControlName="tenantName" [options]="languageOptions" optionLabel="label" optionValue="value"/>
                    </div>

                    <div class="form-container">
                        <div class="field form-field">
                            <label for="translation-value-{{i}}">{{ "translation.translation" | translate }}</label>
                            <input id="translation-value-{{i}}" pInputText formControlName="applicationSettings">
                        </div>
                    </div>

                    <div class="form-container">
                        <div class="container-content">
                            <p-toggleswitch formControlName="active" inputId="active-{{i}}"/>
                            <label for="active-{{i}}">{{ "translation.true" | translate }}</label>
                        </div>

                        <div class="container-content-action">
                            <p-button severity="danger" [outlined]="true" type="button" (onClick)="deleteTranslation(i)">
                                <i class="pi pi-trash"></i>
                                {{ "button.delete" | translate | uppercase }}
                            </p-button>
                        </div>
                    </div>

                </ng-container>
            </p-card>
        }
    </ng-container>
</form>
</detail-body>
</du-config-detail>
